<template>
  <div class="member-manager">
    <picker
      v-if="availableUsers.length > 0"
      :apiData="availableUsers"
      :value="null"
      value-key="id"
      hidePlaceholder
      placeholder="Add member"
      :key="membersKey"
      @input="onAdd" />
    <div v-else class="empty-picker">All organization members are in this group.</div>

    <div class="member-tags" v-if="members.length > 0">
      <el-tag
        v-for="member in members"
        :key="member.id"
        :closable="!pending[member.id]"
        :class="{ loading: pending[member.id] }"
        @close="onRemove(member)">
        {{ memberLabel(member) }}
      </el-tag>
    </div>
    <div v-else class="empty-members">No members yet.</div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'GroupMemberManager',
  components: { Picker },
  props: {
    organization: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pending: {}
    }
  },
  computed: {
    orgUsers () {
      return this.organization.users || []
    },
    membersKey () {
      return this.members.map(m => m.id).join(',')
    },
    members () {
      if (this.group.members && Array.isArray(this.group.members)) {
        return this.group.members
      }
      if (this.group.memberships && Array.isArray(this.group.memberships)) {
        return this.group.memberships
          .map(m => m.organizationUser)
          .filter(ou => ou && ou.id)
      }
      return []
    },
    availableUsers () {
      const memberIds = new Set(this.members.map(m => m.id))
      return this.orgUsers
        .filter(ou => !memberIds.has(ou.id))
        .map(ou => ({ id: ou.id, name: ou.user ? ou.user.name : ou.name }))
    }
  },
  methods: {
    memberLabel (member) {
      if (member.user) return member.user.name
      if (member.name) return member.name
      return member.id
    },
    async onAdd (selected) {
      if (!selected) return
      const organizationUserId = selected.id || selected
      this.$set(this.pending, organizationUserId, true)
      try {
        await this.$http.post(
          this.$api.organization(this.$route.params.orgId).group(this.group.id).user(organizationUserId).add
        )
        this.$emit('refresh')
      } catch (e) {
        this.$message.error(this.errorMessage(e) || 'Could not add member')
      } finally {
        this.$delete(this.pending, organizationUserId)
      }
    },
    async onRemove (member) {
      const organizationUserId = member.id
      this.$set(this.pending, organizationUserId, true)
      try {
        await this.$http.delete(
          this.$api.organization(this.$route.params.orgId).group(this.group.id).user(organizationUserId).remove
        )
        this.$emit('refresh')
      } catch (e) {
        this.$message.error(this.errorMessage(e) || 'Could not remove member')
      } finally {
        this.$delete(this.pending, organizationUserId)
      }
    },
    errorMessage (e) {
      if (e && e.response && e.response.data) {
        if (typeof e.response.data === 'string') return e.response.data
        if (e.response.data.message) return e.response.data.message
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
  .member-manager {
    padding: 10px 0;
  }

  .empty-picker,
  .empty-members {
    color: $text-light;
    font-size: 12px;
    padding: 10px 0;
  }

  .member-tags {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;

    .el-tag {
      margin: 0 5px 5px 0;

      &.loading {
        opacity: 0.6;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Groups/MemberManager.vue